/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from "@emotion/styled";

import { listPageGutterCss } from "./shellSpacing";

/** Standard outer wrapper for MainLayout list pages (shared page chrome). */
export const ListPageContainer = styled("div")`
  padding-bottom: 5rem;
  ${listPageGutterCss}
`;

const listPageTitleCss = `
  font-weight: 600;
  font-size: 24px;
  line-height: 1.3;
  color: ${({ theme }: { theme: any }) => theme.colors.primary};

  ${({ theme }: { theme: any }) => theme.breakpoints.up("md")} {
    font-size: 32px;
  }
`;

/** Page title row — scales down on narrow viewports. */
export const ListPageHeader = styled("div")`
  padding: 1.25rem 0;
  ${listPageTitleCss}

  ${({ theme }) => (theme as any).breakpoints.up("md")} {
    padding: 1.5rem 0;
  }
`;

/** Page title + primary action (e.g. Trips + Create Trip). */
export const ListPageHeaderRow = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 1.25rem 0;

  ${({ theme }) => (theme as any).breakpoints.up("md")} {
    padding: 1.5rem 0;
    gap: 16px;
  }
`;

export const ListPageTitle = styled("h1")`
  margin: 0;
  flex: 1 1 auto;
  min-width: 0;
  ${listPageTitleCss}
`;

export const ListPageHeaderActions = styled("div")`
  flex-shrink: 0;
  display: flex;
  align-items: center;
`;

export const PageWashBackground = styled("div")`
  background: ${({ theme }) => (theme as any).backgrounds.pageWash};
`;
